import { getCookie } from 'lib/cookies';

import { getAuthToken } from './auth';
import { errorHandlers } from './common';

export const fetchData = async ({
    url,
    method = 'GET',
    permission = null,
}: {
    url: string;
    method: string;
    permission: string | null;
}): Promise<{ data: any; error: any; status?: number; code?: string }> => {
    const token = await getAuthToken();
    const options: {
        method: string;
        headers: any;
    } = {
        method,
        headers: {
            'Content-Type': 'application/json',
            'allow-control-allow-origin': '*',
            'x-user-token': token,
            'x-user-workspace': getCookie('helio-workspace')?.id,
        },
    };

    if (permission) {
        options.headers['x-user-permission'] = permission;
    }

    try {
        const response = await fetch(url, options);

        if (!response.ok) {
            // Preserve the HTTP status and any machine-readable error code
            // (e.g. auth-api's `legacy_decommissioned`) so callers can branch
            // on it without changing the existing `{ data, error }` contract.
            // `clone()` so errorHandlers can still read the body.
            let code: string | undefined;

            try {
                const parsed = (await response.clone().json()) as {
                    detail?: { code?: string } | string;
                };

                if (parsed?.detail && typeof parsed.detail === 'object') {
                    code = parsed.detail.code;
                }
            } catch {
                // Body is not JSON / already consumed; leave code undefined.
            }

            return {
                error: await errorHandlers(response),
                data: null,
                status: response.status,
                code,
            };
        }

        const data = await response.json();

        return { error: null, data };
    } catch (error) {
        return { error: await errorHandlers(error), data: null };
    }
};
